import React from 'react';
import VariantsList from './VariantsList';
import VariantsInStockStatus from './VariantsInStockStatus';
import NestedPanel from '../../../../components-legacy/NestedPanel';

enum PanelSteps {
  VariantsList = 'variants-list',
  StoreSelect = 'store-select',
}

const renderPanelStep = (
  step: string,
  _: string[],
  goToStep: (newStep: string) => void,
  goBack: () => void,
  onClose: () => void,
) => {
  switch (step) {
    case PanelSteps.VariantsList:
      return (
        <VariantsList
          handleChangeStore={() => goToStep('store-select')}
          handleSelectVariant={onClose}
        />
      );
    case PanelSteps.StoreSelect:
      return <VariantsInStockStatus onStoreSelect={() => goBack()} />;
    default:
      break;
  }
};

interface IVariantsInStockPanel {
  onClose: () => void;
}

export default function VariantsInStockPanel({ onClose }: IVariantsInStockPanel) {
  return (
    <NestedPanel initialStep={PanelSteps.VariantsList} onClose={onClose}>
      {renderPanelStep}
    </NestedPanel>
  );
}
